export function fluidFontSize(
	targetFontsize: number,
	targetContainerWidth: number,
	currentContainerWidth: number
) {
	return Number(
		(targetFontsize * (currentContainerWidth / targetContainerWidth)).toFixed(3)
	);
}
